import React, { useState, forwardRef } from 'react';
import { Avatar as HeroAvatar } from '@heroui/react';

export interface AvatarProps {
  name?: string;
  src?: string;
  fallback?: React.ReactNode;
  icon?: React.ReactNode;
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'full';
  color?: 'default' | 'primary' | 'danger' | 'success' | 'warning';
  variant?: 'light' | 'solid' | 'faded' | 'bordered';
  isBordered?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showFallbackOnError?: boolean;
}

const Avatar = forwardRef<HTMLSpanElement, AvatarProps>(
  (
    {
      name,
      src,
      fallback,
      icon,
      radius = 'full',
      color = 'primary',
      isBordered = false,
      className = '',
      size = 'lg',
      showFallbackOnError = true,
    },
    ref,
  ) => {
    const [imgError, setImgError] = useState(false);

    const shouldShowFallback = showFallbackOnError && (!src || imgError);

    return (
      <HeroAvatar
        ref={ref}
        name={name}
        src={!shouldShowFallback ? src : undefined}
        icon={icon}
        color={color}
        isBordered={isBordered}
        radius={radius}
        size={size}
        className={className}
        onError={() => setImgError(true)}
      >
        {shouldShowFallback && fallback}
      </HeroAvatar>
    );
  },
);

Avatar.displayName = 'Avatar';

export default Avatar;
